'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = function (_ref, config) {
  var files = _ref.files,
      deps = _ref.deps,
      _ref$template = _ref.template,
      template = _ref$template === undefined ? 'create-react-app' : _ref$template;

  if (!config) config = {};
  var _config = config,
      extraFiles = _config.extraFiles,
      extraDependencies = _config.extraDependencies,
      name = _config.name,
      main = _config.main,
      _config$fileName = _config.fileName,
      fileName = _config$fileName === undefined ? 'example' : _config$fileName;

  var dependencies = (0, _extends3.default)({}, deps, extraDependencies);
  main = !main && template === 'create-react-app-typescript' ? 'index.tsx' : 'index.js';

  if (template === 'create-react-app' || template === 'create-react-app-typescript') {
    ensureReact(dependencies);
  }

  if (template === 'vue-cli') {
    ensureVue(dependencies);
  }

  var finalFiles = (0, _extends3.default)({}, files, {
    'package.json': {
      content: (0, _packagejson2.default)(dependencies, name, main)
    },
    'sandbox.config.json': {
      content: (0, _stringify2.default)({
        template: template
      })
    }
  }, extraFiles);
  var parameters = (0, _getParameters2.default)({
    files: finalFiles
  });
  return {
    files: finalFiles,
    dependencies: dependencies,
    parameters: parameters,
    fileName: fileName
  };
};

var _getParameters = require('./getParameters');

var _getParameters2 = _interopRequireDefault(_getParameters);

var _packagejson = require('../templates/packagejson');

var _packagejson2 = _interopRequireDefault(_packagejson);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ensureReact = function ensureReact(deps) {
  if (!deps.react && !deps['react-dom']) {
    deps.react = 'latest';
    deps['react-dom'] = 'latest';
  } else if (!deps.react) {
    deps.react = deps['react-dom'];
  } else if (!deps['react-dom']) {
    deps['react-dom'] = deps.react;
  }
};

var ensureVue = function ensureVue(deps) {
  if (!deps.vue) {
    deps.vue = 'latest';
  }
};